
import { ReminderConfig } from "@/models/dossier-configs/reminder-config";
import { ReminderTemplate } from "@/models/reminder-template";
import { DossierConfigService } from "@/services/dossier-config-service";
import { UserConfigService } from "@/services/user-config-service";
import { ReminderService } from "@/services/reminder-service";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { IBreadCrumb } from "winfakt-vue-components";

import AppReminderDocuments from "@/components/settings-default/ReminderDocuments.vue";
import AppReminderEmails from "@/components/settings-default/ReminderEmails.vue";
import AppReminderSettings from "@/components/settings-default/ReminderSettings.vue";
import { ReminderEmailTemplate } from "@/models/reminder-email-template";

import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { HttpError } from "@/utils/services/http-error";
import { ReminderSettings } from "@/models/user-configs/reminder-settings";

export default FormLike.extend({
	data() {
		return {
			config: undefined as ReminderConfig | undefined,
			userConfig: new ReminderSettings(),
			templates: [] as ReminderTemplate[],
			send: Boolean,
			layouts: [] as DocumentLayoutInfo[],
			emailTemplates: [] as ReminderEmailTemplate[]
		};
	},
	computed: {
		tab(): number {
			return parseInt(this.$route.params.tab || "0");
		},
		tabs(): any {
			return this.$ct("reminder-tabs");
		},
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/",
					value: this.$ct("general")
				},
				{
					value: this.$ct("reminders")
				}
			] as IBreadCrumb[];
		},
	},
	watch: {
		async tab(){
			setTimeout(() => {
				this.validate();
			}, 150);
		}
	},
	methods: {
		async save() {
			if (!this.config) return;
			if (this.config.AutomaticRemindersEnabled && !this.config.validateAutomaticSettings()) {
				this.$wf.notify(this.$ct("error-auto-reminders-order-wrong"), "danger", 3000, "exclamation-triangle");
				return;
			}
			await this.saveValidateAutomationLayout();
			await DossierConfigService.setReminderConfig(this.config);
			await UserConfigService.setReminderSettings(this.userConfig);
			await ReminderService.putReminderTemplates(this.templates);
			this.$wf.notify(this.$t("saved").toString(), "success", 3000, "check");
		},
		async saveValidateAutomationLayout(){
			if (!this.config) return;
			if (this.config.AutomaticRemindersEnabled) {
				try{
					await ReminderService.getReminderLayout(this.config.AutomaticLayoutID);
				}catch(err){
					let error = err as HttpError;
					if (error.status == 404){
						this.onTab(0);
					}
					throw err;
				}
			}
		},
		async updateLayouts() {
			await ReminderService.getReminderLayouts();
		},
		async updateEmailTemplates() {
			this.emailTemplates = await ReminderService.getEmailTemplates();
		},
		async restoreTemplates() {
			let confirm = await this.$wf.confirm(this.$ct("restore-email-templates"),
				this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (confirm) {
				this.templates = await ReminderService.restoreReminderTemplates();
			}
		},
		onTab(event: number) {
			this.$router.push("/settings/reminders/" + event);
		}
	},
	async mounted() {
		this.config = DossierConfigService.getReminderConfig();
		this.userConfig = UserConfigService.getReminderSettings();
		this.templates = await ReminderService.getReminderTemplates();
		this.layouts = await ReminderService.getReminderLayouts();
		this.emailTemplates = await ReminderService.getEmailTemplates();
		this.validate();
	},
	components: {
		AppReminderDocuments,
		AppReminderSettings,
		AppReminderEmails,
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
